<template>
  <v-container bg fill-height grid-list-md text-xs-center>
    <v-row align="center" justify="center">
      <v-card width="60%" style="border-radius: 10px" class="elevation-20">
        <v-container grid-list-xs class="mx-1">
          <v-col col="12" class="mb-2">
            <div>
              <span class="headline font-weight-bold">Sign Up</span>
            </div>
            <span
              class="caption"
            >By signing up You will be granted an account to vote or submit project ideas.</span>
          </v-col>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-col col="12">
              <v-row justify="start">
                <v-flex class="mx-3">
                  <v-text-field
                    v-model="firstName"
                    :rules="nameRules"
                    label="First Name"
                    required
                    placeholder="Abebe"
                    outlined
                    color="black"
                  ></v-text-field>
                </v-flex>

                <v-flex class="mx-3">
                  <v-text-field
                    v-model="lastName"
                    :rules="nameRules"
                    label="Last Name"
                    required
                    placeholder="Kebede"
                    outlined
                    color="black"
                  ></v-text-field>
                </v-flex>
              </v-row>
              <!--  -->
              <v-row justify="start">
                <v-col cols="7">
                  <v-flex>
                     <v-select
                      v-model="profession"
                      :items="professions"
                      label="Profession"
                      outlined
                      color="black"
                      :rules="[v => !!v || 'Profession is required']"
                    ></v-select>
                  </v-flex>
                </v-col>
                <v-col cols="5">
                  <v-flex>
                    <v-select
                      v-model="gender"
                      :items="genders"
                      label="Gender"
                      outlined
                      color="black"
                      :rules="[v => !!v || 'Gender is required']"
                    ></v-select>
                  </v-flex>
                </v-col>
              </v-row>
              <!--  -->
              <v-flex>
                <v-text-field
                  v-model="userName"
                  :rules="[value => !!value || 'Required.', v => (v || '' ).length > 4 || 'Username must be atleast 4 characters or more', v => (v || '' ).length <= 20 || 'Username must be atmost 20 characters or less']"
                  label="User Name"
                  required
                  placeholder="abekebe"
                  outlined
                  color="black"
                ></v-text-field>
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[value => !!value || 'Required.', v => v.length >= 8 || 'Min 8 characters']"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Password"
                  hint="At least 8 characters"
                  counter
                  @click:append="show1 = !show1"
                  required
                  outlined
                  color="black"
                ></v-text-field>
              </v-flex>
              <v-checkbox
                v-model="checkbox"
                :rules="[v => !!v || 'You must agree to continue!']"
                label="By Signing up, you have agreed to Timertaleh's Terms and Conditions."
                required
                color="black"
              ></v-checkbox>

              <v-btn
                :disabled="!valid"
                medium
                color="success"
                class="mr-4 mt-3 elevation-15"
                @click="validate"
                outlined
              >
                <span class="subheading">Sign Up</span>
              </v-btn>
            </v-col>
          </v-form>

          <v-container fluid justify="end" align="end">
            <v-row justify="end" align="end" class="mt-5 mr-2">
              <span class="grey--text darken-2">Already Registered?</span>
              <span class="primary--text ml-2" @click="login" style="cursor: pointer">LogIn</span>
            </v-row>
          </v-container>
        </v-container>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    show1: false,
    valid: true,
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 20) || "Name must be less than 20 characters",
      value => !!value || "Required."
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    checkbox: false,
    firstName: null,
    lastName: null,
    userName: null,
    password: null,
    profession: null,
    gender: null,
    errors: [],
    genders: ["Male", "Female"],
    professions: ["Software Engineer", "Student", "Developer"],
    response: []
  }),

  methods: {
    ...mapActions("auth", ["signup"]),
    validate() {
      if (this.$refs.form.validate()) {
        var data = {
          username: this.userName,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          // role: "admin",
          proffession: this.profession,
          sex: this.gender
        };
        this.signup(data);
      }
    },
    login() {
      this.$router.push("/");
    }
  }
};
</script>